/**
 * Created by admin on 2018/5/28.
 */
import styled from 'styled-components';
import React from 'react';

export const OperateSpan = styled.span`
  color: #4680FF;
  margin-right: 10px;
  cursor: pointer;
`;

export const Btn = styled.button`
  width: ${props => (props.width ? props.width + 'px' : '90px')};
  height: ${props => (props.height ? props.height + 'px' : '34px')} !important;
  line-height: ${props =>
    props.height ? props.height + 'px' : '34px'} !important;
  background: ${props => (props.primary ? '#4680FF' : '#FFF')} !important;
  border-color: ${props =>
    props.primary || props.ghost ? '#4680FF' : '#E1E1E1'} !important;
  color: ${props =>
    props.primary ? '#FFF' : props.ghost ? '#4680FF' : '#333'} !important;
  font-size: ${props =>
    props.fontSize ? props.fontSize + 'px' : '14px'} !important;
  i {
    font-size: ${props =>
      props.fontSize ? props.fontSize + 'px' : '14px'} !important;
    margin-right: 3px;
  }
`;
export const TriangleWrap = styled.div`
  border: 1px solid #c0bdc9;
  border-radius: 4px;
  position: relative;
`;

export const Sign = styled.i`
  color: red;
  font-size: 16px;
  margin-right: 5px;
`;
export const RequiredSign = () => <Sign>*</Sign>;



// WEBPACK FOOTER //
// ./src/components/Widgets.js